<mat-form-field appearance="outline" [formGroup]="formGroup">
  <mat-label *ngIf="placeholderText">{{placeholderText}}</mat-label>
  <input matInput placeholder="dd/mm/yyyy" formControlName="{{controlName}}" tabindex="{{tabindex}}" required="{{required}}">
  <!--
  <input #text matInput [matDatepicker]="picker" placeholder="dd/mm/yyyy" formControlName="controlName" (keyup)="dateProcessor(text.value, text)">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker> -->
  <mat-error>
    <ng-container *ngIf="formGroup.get(controlName).hasError('futureDate')">Please enter a valid date and check it is future dated.</ng-container>
    <ng-container *ngIf="formGroup.get(controlName).hasError('minAge') || formGroup.get(controlName).hasError('maxAge') || formGroup.get(controlName).hasError('not-older-than')">
      Date of birth is invalid. Individual's age is outside policy
    </ng-container>
    <ng-container *ngIf="formGroup.get(controlName).hasError('required') ||
                          formGroup.get(controlName).hasError('not-specified') ||
                          formGroup.get(controlName).hasError('not-date') ||
                          formGroup.get(controlName).hasError('invalidDate')">
      Please enter a valid date
    </ng-container>
  </mat-error>
</mat-form-field>
